import React, { useState } from "react";
import { useSelector } from "react-redux";
import classes from "./CopyQuoteLinkButton.module.css";

const CopyQuoteLinkButton = () => {
  const [copied, setCopied] = useState(false);

  const checkIn = useSelector((s) => s.booking.checkInDate);
  const checkOut = useSelector((s) => s.booking.checkOutDate);
  const totalGuests = useSelector((s) => s.booking.totalGuests);
  const totalRooms = useSelector((s) => s.booking.totalRooms);
  const g1Email = useSelector((s) => s.booking.guest1ReturningEmail);
  const g2Email = useSelector((s) => s.booking.guest2ReturningEmail);

  const handleCopy = async () => {
    const base = window.location.origin;
    const params = new URLSearchParams();

    if (checkIn && checkOut) {
      params.set("start", checkIn.replace(/\//g, "-"));
      params.set("end", checkOut.replace(/\//g, "-"));
    }
    params.set("guests", totalGuests);
    params.set("rooms", totalRooms);
    if (g1Email) params.set("g1", g1Email);
    if (g2Email) params.set("g2", g2Email);

    const fullUrl = `${base}/?${params.toString()}`;

    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className={classes.container}>
      <button
        onClick={handleCopy}
        className={`${classes.linkIcon} ${copied ? classes.copied : ""}`}
        title={copied ? "Copied!" : "Copy Quote Link"}
      >
        {copied ? "✅" : "🔗"}
      </button>
    </div>
  );
};

export default CopyQuoteLinkButton;
